import { ColumnType } from "antd/es/table";

import { ContractGridDto } from "interfaces";
import { getColumns as getColumnsContractList } from "pages/ContractsPage/getColumns";
import { UserStore } from "stores/UserStore";

export const getColumns = (user: UserStore): Array<ColumnType<ContractGridDto>> => {
  const columns = getColumnsContractList(user);
  return columns.filter((c) => c.dataIndex !== "companyName");
};
